module.exports = __webpack_public_path__ + "img/7.bfc91fe.png";